//CRN_20250922 - This is not used, perhaps in the future 🤷

import { Component, Input, OnInit } from '@angular/core';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';

@Component({
  selector: 'app-page-comp-control-ribbon',
  templateUrl: './page-comp-control-ribbon.component.html',
  styleUrls: ['./page-comp-control-ribbon.component.scss']
})

export class PageCompControlRibbonComponent implements OnInit {

  // @Input() breadcrumbItems!: Array<{ active?: boolean; label?: string; }>;
  // @Input() title           : string | undefined;
  
  // get showBreadcrumbs() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowBreadcrumbs, false ); }

  constructor(
    private configSystemService: ConfigSystemService
  ) { }

  public ngOnInit(): void { }
}
